module.exports = __webpack_public_path__ + "static/bg_slise-bbc06ed45e1bf6bcc3271dcfec4f85b1.jpg";